export const COLOR_ISLAND = '#1a1a1c';
export const COLOR_BUS_HEAD = '#e74c3c';
export const COLOR_BUS_BODY = '#c0392b';
export const COLOR_STUDENT_SHIRT = '#a93226';
export const COLOR_STUDENT_PANTS = '#2980b9';
export const COLOR_STUDENT_SKIN = '#f1c40f';

export const UI_DARK_BG = '#922b21';
export const UI_BUTTON_RED = '#e74c3c';

export const routeStations = [
    "Piazza Cavour",
    "P.Le Libertà",
    "1^ Via Bocconi",
    "Cimitero Tavernelle",
    "1^ Via S. Giacomo Della Marca",
    "Via S. Giacomo D. Marca - Fioraia",
    "Liceo Galilei",
    "Universita Ingegneria"
];

export const FINAL_CRASH_STATION_INDEX = 4;

export const ironicMessages = [
    "Patente Sospesa!",
    "Questo non è un rally!",
    "Il Rettore non sarà felice...",
    "Hai scambiato il bus per un go-kart?",
    "Ripassa il codice della strada!",
    "Troppa fretta di andare a lezione?",
    "Ancona non è fatta per questa velocità!"
];
